import React from 'react';

import SneezingFaceUrl from '@pkg/assets/images/sneezing-face.png';
import { DepButton, DepInput, DepInputSize } from '@pkg/components/deprecated';
import { usePassword } from '@pkg/hooks';

import { Typography } from '../../DesignSystem';
import { Container, EmojiImage, FormGroup, FormRow, PrimaryCopySection, Section } from '../Web3Auth.style';
import { Web3AuthSteps } from '../Web3Auth.types';
import { useWeb3AuthContext } from '../context';

export function ForgotPassword() {
    const { authEmail, setAuthEmail, setCurrentStep } = useWeb3AuthContext();

    const { sendPasswordResetEmail } = usePassword();

    function handleEmailChange(event) {
        setAuthEmail(event.target.value);
    }

    function handleSendRecoveryLink() {
        sendPasswordResetEmail({ email: authEmail });
        setCurrentStep(Web3AuthSteps.ForgotPasswordConfirmation);
    }

    return (
        <Container>
            <Section className="hide-on-tablet">
                <EmojiImage src={SneezingFaceUrl} />
            </Section>

            <PrimaryCopySection>
                <Typography type="headline" size={40}>
                    Forgot my password
                </Typography>
                <Typography type="paragraph" size={18} faded={true}>
                    No worries! Enter the email associated with your account and we&apos;ll send you a recovery link.
                </Typography>
            </PrimaryCopySection>

            <Section>
                <FormGroup>
                    <FormRow>
                        <DepInput
                            label="Email"
                            value={authEmail}
                            onChange={handleEmailChange}
                            sizeVariant={DepInputSize.Compact}
                        />
                    </FormRow>

                    <FormRow>
                        <DepButton variant="glow" disabled={!authEmail} onClick={handleSendRecoveryLink}>
                            Send Recovery Link
                        </DepButton>
                    </FormRow>
                </FormGroup>
            </Section>
        </Container>
    );
}
